import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "height": "auto"
  }
};
const _hoisted_2 = {
  class: "product-background"
};
const _hoisted_3 = {
  class: "product-title"
};
const _hoisted_4 = {
  class: "product-content"
};
const _hoisted_5 = {
  class: "product-title",
  style: {
    "color": "black"
  }
};
const _hoisted_6 = {
  class: "space"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "product-name"
};
const _hoisted_9 = ["textContent"];
const _hoisted_10 = {
  class: "space"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "product-name"
};
const _hoisted_13 = ["textContent"];
const _hoisted_14 = {
  class: "space"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "product-name"
};
const _hoisted_17 = ["textContent"];
const _hoisted_18 = {
  class: "space"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "product-name"
};
const _hoisted_21 = ["textContent"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("text", _hoisted_3, _toDisplayString(_ctx.$t('messages.main_Unique_title')), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('messages.main_Unique_detail')), 1)]), _createElementVNode("div", null, [_createElementVNode("text", _hoisted_5, _toDisplayString(_ctx.$t('messages.main_products')), 1)]), _createVNode(_component_van_row, {
    justify: "center",
    gutter: "[20,20]"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_col, {
      span: "6"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
        src: $data.imagelist[0].img,
        alt: "Carousel Image",
        class: "carousel-image",
        onClick: _cache[0] || (_cache[0] = $event => $options.OnProduct_click(0))
      }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        textContent: _toDisplayString($options.get_product_name(0))
      }, null, 8, _hoisted_9)])]),
      _: 1
    }), _createVNode(_component_van_col, {
      span: "6"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
        src: $data.imagelist[2].img,
        alt: "Carousel Image",
        class: "carousel-image",
        onClick: _cache[1] || (_cache[1] = $event => $options.OnProduct_click(2))
      }, null, 8, _hoisted_11)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        textContent: _toDisplayString($options.get_product_name(2))
      }, null, 8, _hoisted_13)])]),
      _: 1
    }), _createVNode(_component_van_col, {
      span: "6"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
        src: $data.imagelist[6].img,
        alt: "Carousel Image",
        class: "carousel-image",
        onClick: _cache[2] || (_cache[2] = $event => $options.OnProduct_click(6))
      }, null, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
        textContent: _toDisplayString($options.get_product_name(6))
      }, null, 8, _hoisted_17)])]),
      _: 1
    }), _createVNode(_component_van_col, {
      span: "6"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
        src: $data.show_more,
        alt: "Carousel Image",
        class: "carousel-image",
        onClick: _cache[3] || (_cache[3] = $event => $options.goto_more_product())
      }, null, 8, _hoisted_19)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
        textContent: _toDisplayString($options.text_more_product())
      }, null, 8, _hoisted_21)])]),
      _: 1
    })]),
    _: 1
  })]);
}